import { render, staticRenderFns } from "./alive.vue?vue&type=template&id=9e3475b2&scoped=true&lang=html&"
import script from "./alive.vue?vue&type=script&lang=js&"
export * from "./alive.vue?vue&type=script&lang=js&"
import style0 from "./alive.vue?vue&type=style&index=0&id=9e3475b2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3475b2",
  null
  
)

component.options.__file = "alive.vue"
export default component.exports